export default __webpack_public_path__ + "static/media/CISCO NDG Linux.65f9d52d.webp";